export interface ApnsPushODataInterface {
    __metadata: {
        id: string;
        uri: string;
        type: 'HC_SM_NGM_58_SRV.RegisterApnsPushService';
    };
    FrontId: string;
    SalesOrg: string;
    Plant: string;
    AppID: string;
    ApnsID: string;
}

export function isApnsPushObject(obj: unknown): obj is ApnsPushODataInterface {
    return typeof obj === 'object' && obj !== null && (obj as Record<string, unknown>).hasOwnProperty('ApnsID');
}
